module.exports = __webpack_public_path__ + "img/join.8063edec.png";